import { auditKeys } from "@amber/access/ui";

export const operationsKeys = {
  all: ["operations"],
  tasks: (params: unknown) => ["operations", "tasks", params] as const,
  task: (id: string) => ["operations", "task", id] as const,
  tasksSummary: ["operations", "tasks-summary"],
  pauses: ["operations", "pauses"],
  pipeline: ["operations", "pipeline"],
  resumePreview: (id: string) => ["operations", "resume-preview", id] as const,
  ruleValues: ["operations", "rule-values"],
  rulePreview: (rule: string, value: unknown) => ["operations", "rule-preview", rule, value] as const,
  budgets: ["operations", "budgets"],
  budgetBanner: ["operations", "budget-banner"],
  budgetPreview: (values: unknown) => ["operations", "budget-preview", values] as const,
  jobs: ["operations", "jobs"],
  dependencies: ["operations", "dependencies"],
} as const;

export const AFTER_OPERATIONS_CHANGE = [operationsKeys.all, auditKeys.all] as const;
export const AFTER_OPERATIONS_CONFLICT = [operationsKeys.all] as const;
